const MAX_TITLE_LENGTH = 70;
const MAX_DESCRIPTION_LENGTH = 320;

const ELLIPSIS_LENGTH = 2;
const ELLIPSIS = '&hellip;';

const TITLE_FIELD_CLASS = '.js-google-example-title';
const DESCRIPTION_FIELD_CLASS = '.js-google-example-description';

const GoogleExample = {
  /**
   * Create Google example widget
   * @param {HTMLElement} node
   * @param {Object} props
   * @return {Void}
   */
  create(node, props) {
    // Get the input fields for SEO information
    this.titleInput = document.getElementById(props.googleTitle);
    this.descriptionInput = document.getElementById(props.googleDescription);

    // Get the elements where we output the SEO information
    this.titleOutput = node.querySelector(TITLE_FIELD_CLASS);
    this.descriptionOutput = node.querySelector(DESCRIPTION_FIELD_CLASS);

    // Listen for changes on the input
    this.titleInput.addEventListener('keyup', this.onChange.bind(this));
    this.descriptionInput.addEventListener('keyup', this.onChange.bind(this));

    // Run it for the first time
    this.onChange();
  },

  /**
   * Truncate strings to a maximum length and end it with an ellipsis
   * @param {String} str
   * @param {Number} len
   * @return {String}
   */
  truncate(str, len) {
    if (str.length <= len) {
      return str;
    }

    return `${str.substring(0, len - ELLIPSIS_LENGTH)}${ELLIPSIS}`;
  },

  /**
   * Handle changes on the SEO input fields
   * @return {Void}
   */
  onChange() {
    // Get the values
    const titleValue = this.titleInput.value;
    const descriptionValue = this.descriptionInput.value;

    // Output values to the DOM
    this.titleOutput.innerHTML = this.truncate(titleValue, MAX_TITLE_LENGTH);
    this.descriptionOutput.innerHTML = this.truncate(descriptionValue, MAX_DESCRIPTION_LENGTH);
  },
};

export default GoogleExample;
